import { render, staticRenderFns } from "./SortingTable.vue?vue&type=template&id=6ae5c6ad&"
import script from "./SortingTable.vue?vue&type=script&lang=js&"
export * from "./SortingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports